(function () {
    angular.module('PWAPoCApp').constant('appVersion', '26.06.16');
})();
